import usersQuery from "./users.query.mock"

export default [usersQuery]
